/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'
import 'detect-autofill'
import { debounce } from 'throttle-debounce'

import './speedbump.js'
import './slideshows.js'
import './webchat.js'
import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion.js'
import sectionTabs from './section-tabs.js'
import {initAlert} from './alert-bar.js'


(($) => {

    $.fn.responsiveNav = responsiveNav;
    $.fn.accordion = accordion;
    $.fn.sectionTabs = sectionTabs;

    initAlert();

    //if the tab section exists and there is a tab list
    // help center, rates, locations
    if( $('.tabbed-section').length > 0 && $('.button-tabs').length > 0 ){
        $('.tabbed-section').sectionTabs();
    }

    //rates anchor links mobile toggle
    if( $('.anchor-links-toggle') ){
        $('.anchor-links-toggle').on('click', function(e){
            e.preventDefault();
            $(this).toggleClass('open');
            $(this).next().slideToggle();
        });
    }

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav();

    // Responsive Videos
    $('.rtecontent').fitVids();
    $(".rtecontent").fitVids({ customSelector: "iframe[data-src*='youtube'], iframe[data-src*='vimeo']"});

    // Accordions
    $('dl.accordion').accordion();

    //new/blog filters
    $('#categoryFilter').on('change',function(){
		var catLink = $(this).val();
		window.location = catLink;
	});

    //help center sidebar
    $('.mobile-toggle').on('click', function(){
        $(this).next().slideToggle();
    });

    //link popup (used for timetrade popups)
    $('.js-timetrade-popup').magnificPopup({
        type: 'iframe',
        alignTop: true,
        closeMarkup: '<button type="button" class="popup__close mfp-close"><span>Close</span> <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.9728 24.9728C26.9817 22.9638 28.3499 20.4042 28.9042 17.6177C29.4584 14.8311 29.174 11.9428 28.0867 9.31794C26.9995 6.69308 25.1583 4.44958 22.7959 2.87113C20.4336 1.29269 17.6563 0.450193 14.8152 0.450192C11.974 0.450193 9.19673 1.29269 6.83441 2.87113C4.4721 4.44958 2.6309 6.69308 1.54365 9.31794C0.456399 11.9428 0.171923 14.8311 0.7262 17.6177C1.28048 20.4042 2.64861 22.9638 4.65759 24.9728C7.35155 27.6667 11.0053 29.1802 14.8152 29.1802C18.625 29.1802 22.2788 27.6667 24.9728 24.9728ZM8.88992 19.0475L12.9106 15.0268C12.9668 14.9707 12.9983 14.8946 12.9983 14.8152C12.9983 14.7358 12.9668 14.6597 12.9106 14.6036L8.88992 10.5829C8.66542 10.3584 8.5393 10.0539 8.5393 9.7364C8.5393 9.41891 8.66542 9.11443 8.88992 8.88993C9.11442 8.66543 9.4189 8.53931 9.73638 8.53931C10.0539 8.53931 10.3584 8.66543 10.5828 8.88993L14.6036 12.9106C14.6597 12.9668 14.7358 12.9983 14.8152 12.9983C14.8945 12.9983 14.9707 12.9668 15.0268 12.9106L19.0475 8.88993C19.272 8.66543 19.5765 8.53931 19.894 8.53931C20.2115 8.53931 20.5159 8.66543 20.7404 8.88993C20.9649 9.11443 21.0911 9.41891 21.0911 9.73639C21.0911 10.0539 20.9649 10.3584 20.7404 10.5829L16.7197 14.6036C16.6636 14.6597 16.6321 14.7358 16.6321 14.8152C16.6321 14.8946 16.6636 14.9707 16.7197 15.0268L20.7404 19.0475C20.9649 19.272 21.0911 19.5765 21.0911 19.894C21.0911 20.2115 20.9649 20.516 20.7404 20.7404C20.5159 20.9649 20.2115 21.0911 19.894 21.0911C19.5765 21.0911 19.272 20.9649 19.0475 20.7404L15.0268 16.7197C14.9707 16.6636 14.8945 16.6321 14.8152 16.6321C14.7358 16.6321 14.6597 16.6636 14.6036 16.7197L10.5829 20.7404C10.3584 20.9649 10.0539 21.0911 9.73638 21.0911C9.4189 21.0911 9.11442 20.9649 8.88992 20.7404C8.66542 20.516 8.5393 20.2115 8.5393 19.894C8.5393 19.5765 8.66542 19.272 8.88992 19.0475Z" fill="white"/></svg></button>',
        mainClass: 'mfp-fade mfp-timetrade',
        iframe: {
            patterns: {
                timetrade:{
                    index: 'timetrade.com',
                    src: '%id%&view=embed'
                }
            }
        },
        callbacks: {
            beforeOpen: function() {
                $('body').css('overflow', 'hidden');
            },
            beforeClose: function() {
                $('body').css('overflow', 'auto');
            },
        }
    });

    //SEARCH POPUP
    $('.js-open-search').magnificPopup({
        type:'inline',
        alignTop: true,
        closeOnContentClick: false,
        closeOnBgClick: false,
        showCloseBtn: false,
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        mainClass: 'mfp-fade',
        focus : '#s',
        callbacks: {
            // When elemened is focused, some mobile browsers in some cases zoom in
            // It looks not nice, so we disable it:
            beforeOpen: function() {
                $('body').css('overflow', 'hidden');
                if($(window).width() < 700) {
                    this.st.focus = false;
                } else {
                    this.st.focus = '#s';
                }
            },
            beforeClose: function() {
                $('body').css('overflow', 'auto');
            },
        }
    });
    //login popup
    $('.js-open-login').magnificPopup({
        type:'inline',
        alignTop: true,
        closeOnContentClick: false,
        closeOnBgClick: false,
        showCloseBtn: false,
        midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
        mainClass: 'mfp-fade mfp-login',
        callbacks: {
            change: function(){
                if( this.content[0].classList.contains('popup--speedbump') ){
                    //if this gets opened inside the login popup change out the popup mainClass
                    $('.mfp-bg').addClass('mfp-speedbump').removeClass('mfp-login');
                    $('.mfp-wrap').addClass('mfp-speedbump').removeClass('mfp-login');
                }
            },
            beforeOpen: function() {
                $('body').css('overflow', 'hidden');
            },
            beforeClose: function() {
                $('body').css('overflow', 'auto');
            }
        }
    });
    $(document).on('click', '.js-close-popup', function (e) {
        e.preventDefault();
        $.magnificPopup.close();
    });

    $(window).on('resize', debounce(150, function() {
        if( !$('.anchor-links-toggle').is(':visible') ){
            $('.anchor-links-toggle').removeClass('open');
            $('.anchor-links-toggle').next().removeAttr('style');
        }

        if( !$('.mobile-toggle').is(':visible') ){
            $('.mobile-toggle').next().removeAttr('style');
        }
    }));
    
    // Calculate and display the user's distance from a location when appropriate/possible
    // Should only run when viewing a single location post 
    if (document.body.classList.contains('single-location')) {
        const locationDetails = document.querySelector('.location-details');
        const userLat = localStorage.getItem('userLocationLat');
        const userLng = localStorage.getItem('userLocationLng');

        // If we have the user's location in localstorage
        if (userLat !== null && userLng !== null) {
            const params = new URLSearchParams({
                action: 'get_user_distance',
                user_lat: userLat,
                user_lng: userLng,
                location_id: locationDetails.dataset.id ?? 0,
            });
            fetch(`${site_data.WP_AJAX}?${params}`)
                .then(response => response.json())
                .then(result => {
                    const address = document.querySelector('.image-details-row__content address');
                    if (address && result.success) {
                        address.outerHTML += (result.markup ?? '');
                    }
                });
        }
    }

    //LOGIN FORM ANIMATE LABEL
    Array.from(document.querySelectorAll('.floating-label > .form-control')).forEach((field) => {
        // Keep value attr in sync with the underlying DOM property. This lets us
        // target elements with non-empty value attributes directly in the css.
        field.addEventListener('change', () => {
            field.setAttribute('value', field.value);
        });
        field.addEventListener('onautocomplete', (e) => {
            //do something here to activate floating label styles
            field.blur();
        });
    });

    //LOGIN FORM LABEL ANIMATION

    //SHOW SKIP TO CONTENT LINK ON FOCUS
    $('.skip-to-content-link').on('focus', function () {
        $(this).css('transform', '');
        $(this).css('z-index', 1);
    });
    // hide when unfocused
    $('.skip-to-content-link').on('blur', function () {
        $(this).css('transform', 'translateY(-100%)');
        $(this).css('z-index', 0);
    });
    
})(jQuery)